export default __webpack_public_path__ + "static/media/SFPRODISPLAYBOLD.b1f4d2c6.OTF";